/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_NarrativeInputs */

const en_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform Narrative`)
};

const es_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrativa de la plataforma`)
};

const fr_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récit de la plateforme`)
};

const de_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform-Erzählung`)
};

const ja_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォームのストーリー`)
};

const zh_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台品牌叙事`)
};

const ar_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السرد القصصي للمنصة`)
};

const id_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narasi Platform`)
};

const it_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrativa della Piattaforma`)
};

const ru_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повествование платформы`)
};

const pt_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrativa da Plataforma`)
};

const ko_platform_narrative = /** @type {(inputs: Platform_NarrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랫폼 스토리텔링`)
};

/**
* | output |
* | --- |
* | "Platform Narrative" |
*
* @param {Platform_NarrativeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const platform_narrative = /** @type {((inputs?: Platform_NarrativeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_NarrativeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_platform_narrative(inputs)
	if (locale === "es") return es_platform_narrative(inputs)
	if (locale === "fr") return fr_platform_narrative(inputs)
	if (locale === "de") return de_platform_narrative(inputs)
	if (locale === "ja") return ja_platform_narrative(inputs)
	if (locale === "zh") return zh_platform_narrative(inputs)
	if (locale === "ar") return ar_platform_narrative(inputs)
	if (locale === "id") return id_platform_narrative(inputs)
	if (locale === "it") return it_platform_narrative(inputs)
	if (locale === "ru") return ru_platform_narrative(inputs)
	if (locale === "pt") return pt_platform_narrative(inputs)
	return ko_platform_narrative(inputs)
});